<!--
 * @Author: yuanjianlong
 * @Description: 左侧导航
 * @Date: 2021-11-29 17:03:15
 * @LastEditTime: 2024-09-21 00:16:57
 * @FilePath: /teacher-h5/src/components/ComMenu.vue
-->
<template>
  <div
    class="com-menu"
    :class="{collapsed: collapsed, fixed: isFixed, setBg: isSupervision}"
    :style="{background: isSupervision ? '#191B22' : '#fff'}"
    @mouseover="handleMouseover"
    @mouseleave="handleMouseleave"
  >
    <a-menu
      mode="inline"
      :open-keys.sync="openKeys"
      :inline-collapsed="collapsed"
      v-model="selectedKeys"
      :inline-indent="16"
    >
      <template v-for="(item) in menuList">
        <template v-if="!item.children || item.children.length <= 0">
          <!-- 'GoldList',  -->
          <template v-if="['StudentRights'].includes(item.key)">
            <a-menu-item v-gdd-hide :key="item.key">
              <router-link :to="{name: item.key}">
                <div class="icon-wrap">
                  <SvgIcon :icon="item.icon" />
                </div>
                <span>{{ item.title }}</span>
              </router-link>
            </a-menu-item>
          </template>
          <template v-else>
            <a-menu-item :key="item.key">
              <router-link :to="{name: item.key}">
                <div class="icon-wrap">
                  <SvgIcon :icon="item.icon" />
                </div>
                <span>{{ item.title }}</span>
              </router-link>
            </a-menu-item>
          </template>
        </template>

        <template v-else>
          <a-sub-menu :key="item.key">
            <span slot="title">
              <div class="icon-wrap">
                <SvgIcon :icon="item.icon" />
              </div>
              <span>{{ item.title }}</span>
            </span>
            <a-menu-item v-for="child in item.children" :key="child.key">
              <router-link :to="{name: child.key}">
                <span>{{ child.title }}</span>
              </router-link>
            </a-menu-item>
          </a-sub-menu>
        </template>
      </template>
    </a-menu>
    <template v-if="!collapsed">
      <a-tooltip :overlay-class-name="isSupervision ? 'draw_atooltip' : null">
        <template slot="title">
          {{ !isFixed ? '固定导航' : '取消固定' }}
        </template>
        <span
          class="iconfont"
          :class="{'icon-dingbad': !isFixed, 'icon-dinggod': isFixed, 'fixbox': !isSupervision, 'fixbox-black': isSupervision}"
          @click="handleFixed"
        />
      </a-tooltip>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getStudentRight } from '@/utils/menuTool'
const normalMenuList = [
  {
    title: '上课与批改',
    icon: 'course-and-correct',
    key: 'inClass'
  },
  {
    title: '小组与学员',
    icon: 'group-manage',
    key: 'groupManage'
  },
  {
    title: '课程与小组',
    icon: 'course-and-group',
    key: 'courseAndGroup'
  },
  {
    title: '监课看板',
    icon: 'supervision',
    key: 'supervisionCourse'
  },
  {
    title: '学情看板',
    icon: 'learning-situation',
    key: 'LearningSituation'
  },
  {
    title: '金币增减',
    icon: 'gold',
    key: 'GoldList'
  }
]

const OPEN_KEYS = ['inClass', 'groupManage', 'courseAndGroup']
export default {
  inject: ['userInfo', 'isAdmin', 'isTeacher'],

  data() {
    return {
      openKeys: [], // 当前展开的 SubMenu 菜单项 key 数组
      collapsed: true, // 是否收起 true: 收起 false: 展开
      menuList: [],
      selectedKeys: ['0'], // 当前选中的菜单项 key 数组
      routerName: '', // 路由name
      isFixed: false, // 是否固定导航
      openMouseEvent: true, // 是否开启鼠标事件
      menuStatusKey: '' // 记录上次收起/展开的状态
    }
  },

  watch: {
    $route: 'routerChange'
  },

  computed: {
    ...mapGetters({
      userInfo: 'userInfo/userInfo'
    }),
    isSupervision () {
      return this.$route.path === '/supervisionCourse/list'
    }
  },

  methods: {
    /**
     * 路由切换
     */
    routerChange() {
      const { matched } = this.$route

      if (matched && matched.length > 0) {
        this.selectedKeys = []

        matched.forEach(item => {
          this.selectedKeys.push(item.name)
        })
      }
      console.log('selectedKeys', this.selectedKeys)
    },
    /**
     * 鼠标移入
     */
    handleMouseover() {
      if (!this.isFixed && this.openMouseEvent) {
        this.openKeys = OPEN_KEYS
        this.collapsed = false
        this.openMouseEvent = false
      }
    },
    /**
     * 鼠标离开
     */
    handleMouseleave() {
      if (!this.isFixed) {
        this.openKeys = []
        this.collapsed = true
        this.openMouseEvent = true
      }
    },
    /**
     * 固定导航、取消固定
     */
    handleFixed() {
      this.isFixed = !this.isFixed
      if (!this.isFixed) {
        this.collapsed = true
        this.openMouseEvent = false
        setTimeout(() => {
          this.openMouseEvent = true
        }, 500)
      }
      this.$emit('onFixed', this.isFixed)
      this.$storage.set(this.menuStatusKey, this.isFixed ? 1 : 0)
    },
    dynamicRouter() {
      this.menuList = normalMenuList // 普通权限
      const showRightMenu = getStudentRight()
      if (showRightMenu) {
        const hasSudentRights = this.menuList.find(k => k.key === 'StudentRights')
        if (hasSudentRights) return // 防止重复添加
        this.menuList.push({
          title: '学员权益包管理',
          icon: 'student-rights',
          key: 'StudentRights'
        })
      }
    }
  },

  created() {
    this.menuStatusKey = `menu_status_${this.userInfo.userId}`
    const menuStatus = this.$storage.get(this.menuStatusKey)
    this.isFixed = !!menuStatus
    this.collapsed = !menuStatus
    this.$emit('onFixed', this.isFixed)
    if (this.isFixed) {
      this.openKeys = OPEN_KEYS
    }
    this.routerChange()
    // 临时处理学员权益包，后面如果后端做权限控制，再统一改
    this.dynamicRouter()
  }
}
</script>

<style lang="less" scoped>
@import '~@/static/css/colors.less';

.com-menu {
  width: 180px;
  height: 100%;
  background: #FFFFFF;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 9;
  flex: 0 0 auto;
  position: absolute;
  top: 0;
  left: 0;
  padding-top: 52px;
  transition: width .3s;
  .icon-wrap {
    width: 16px;
    height: 16px;
    margin-right: 14px;
    display: flex;
    align-items: center;
  }
  :deep(.svg-container) {
    font-size: 16px;
    fill: #505873;
  }
  :deep(.ant-menu-item) {
    a {
      display: inline-flex;
      align-items: center;
      &:hover, &.router-link-active {
        .svg-container {
          fill: #3262FD
        }
      }
    }
  }

  &.collapsed {
    width: 44px;
  }

  &.fixed {
    position: relative;
    padding: 0;
  }

  .fixbox {
    position: absolute;
    bottom: 24px;
    right: 16px;
    cursor: pointer;
    color: @gray-4;
    &:hover {
      color: @blue-1;
    }
  }
  .fixbox-black {
    position: absolute;
    bottom: 24px;
    right: 16px;
    cursor: pointer;
    color: @gray-4;
    &:hover {
      color: #fff;
    }
  }
}

.setBg {
  .ant-menu,
  .ant-menu-sub,
  .ant-menu-inline{
    color: white;
    background-color: #191B22 !important;
    .ant-menu-item-selected {
      background: #3D4152;
    }
    :deep(.ant-menu-item) {
      a {
        display: inline-flex;
        align-items: center;
        .svg-container {
          fill: #98A2B2;
        }
        color: #98A2B2;
        &:hover, &.router-link-active {
          .svg-container {
            fill: #fff;
          }
          color: #fff;
        }
      }
    }
  }
  .ant-menu-item::after {
    border-right: 3px solid #4E546D;
  }
}
.draw_atooltip {
    // 气泡颜色
    .ant-tooltip-inner {
        color: #333 !important;
        background-color: #fff !important;
    }
    // 气泡三角形颜色
    .ant-tooltip-arrow::before {
        background-color: #fff;
    }
}
</style>
